import { IconBuilding, IconUserCheck } from "@tabler/icons-react";

interface RoleRequirementNoticeProps {
  isRealtor?: boolean;
  isDeveloper?: boolean;
}

const RoleRequirementNotice = ({
  isRealtor,
  isDeveloper,
}: RoleRequirementNoticeProps) => {
  if (!isRealtor && !isDeveloper) return null;

  if (isDeveloper) {
    return (
      <div
        role="note"
        aria-label="Developer document requirements"
        className="flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4"
      >
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-amber-100 text-amber-700">
          <IconBuilding size={18} />
        </span>
        <div>
          <p className="text-xs font-bold text-amber-900">
            Developer verification
          </p>
          <p className="mt-0.5 text-xs leading-relaxed text-amber-800">
            You must upload <span className="font-bold">both</span> your NIN and
            your CAC.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      role="note"
      aria-label="Realtor document requirements"
      className="flex items-start gap-3 rounded-2xl border border-[#153e46]/15 bg-[#E8F2F4] p-4"
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#153e46]/10 text-[#153e46]">
        <IconUserCheck size={18} />
      </span>
      <div>
        <p className="text-xs font-bold text-[#153e46]">
          Realtor verification
        </p>
        <p className="mt-0.5 text-xs leading-relaxed text-[#153e46]/90">
          You must upload <span className="font-bold">either</span> your NIN or
          your CAC.
        </p>
      </div>
    </div>
  );
};

export default RoleRequirementNotice;
